import { render, staticRenderFns } from "./FilesGallery.vue?vue&type=template&id=7857e7f5&"
import script from "./FilesGallery.vue?vue&type=script&lang=js&"
export * from "./FilesGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports